/* unplugin-vue-components disabled */import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=9473cdfa&lang=css"

const __exports__ = script;

export default __exports__